import { Box, Button, CircularProgress, Typography } from "@mui/material";
import parse from "html-react-parser";

const Messages = ({
    messages,
    loading,
    chatStarted,
    handleModuleSubmit,
    disabledFields,
    setSwitchedComponent,
    setFilterData,
    scrollToLastItem,
    setMessages
}) => {
    return (
        <Box
            component={"div"}
            sx={{
                width: "100%",
                maxWidth: "60rem",
                mx: "auto",
                display: "flex",
                flexGrow: chatStarted ? 1 : 0,
                justifyContent: "end",
                flexDirection: "column",
                gap: 1.5,
                mb: 1.5,
                mt: chatStarted ? "1rem" : "",
            }}
        >
            {messages.map((message, i) => (
                <Box
                    component={"div"}
                    key={i}
                    ref={i === messages.length - 1 ? scrollToLastItem : null}
                    sx={{
                        maxWidth: "70%",
                        display: "flex",
                        flexDirection: "column",
                        alignSelf: message.from === "user" ? "flex-end" : "flex-start",
                    }}
                >
                    <div
                        style={{
                            width: "fit-content",
                            maxWidth: "100%",
                            display: "flex",
                            flexDirection: "column",
                            overflowX: "hidden",
                            wordWrap: "break-word",
                            gap: "0.5rem",
                            padding: "12px",
                            backgroundColor:message.from === "user" ? "#FAF9F6" : "#fefefe",
                            borderRadius: "6px",
                            boxShadow: "0 0.5rem 1.25rem 0 rgba(0, 0, 0, 0.05)",
                        }}
                    >
                        <span>
                            {parse(message.content, {
                                replace: (domNode) => {
                                    if (domNode.name === "p") {
                                        domNode.attribs = {
                                            ...domNode.attribs,
                                            style: "margin: 0",
                                        };
                                    }
                                    if (
                                        domNode.attribs &&
                                        domNode.attribs["data-action"] === "viewStatus"
                                    ) {
                                        return (
                                            <span
                                                onClick={() => {
                                                    setSwitchedComponent(true);
                                                    setFilterData(
                                                        domNode.attribs["data-request-id"]?.toString()
                                                    );
                                                }}
                                                style={{
                                                    cursor: "pointer",
                                                    color: "#005cb9",
                                                    background: "none",
                                                    border: "none",
                                                    textDecoration: "underline",
                                                }}
                                            >
                                                {domNode.children[0].data}
                                            </span>
                                        );
                                    }
                                    return domNode;
                                },
                            })}
                        </span>

                        {message?.buttons?.length > 0 && (
                            <>
                                {message.snapshotIntentState === "ReadyForFulfillment" ? (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 0,
                                            marginTop: ".4rem",
                                            border: "1px solid #d0dff0",
                                            borderRadius: "8px",
                                            overflow: "hidden",
                                            maxHeight: "260px",
                                            overflowY: "auto",
                                        }}
                                    >
                                        {message.buttons.map((button, index) => (
                                            <Box
                                                key={button.value}
                                                onClick={() =>
                                                    !loading &&
                                                    !(i !== messages.length - 1 && disabledFields.intentButton) &&
                                                    handleModuleSubmit({ textInput: button.value })
                                                }
                                                sx={{
                                                    padding: "12px 16px",
                                                    cursor:
                                                        loading || (i !== messages.length - 1 && disabledFields.intentButton)
                                                            ? "not-allowed"
                                                            : "pointer",
                                                    color:
                                                        loading || (i !== messages.length - 1 && disabledFields.intentButton)
                                                            ? "#aaa"
                                                            : "#1a1a2e",
                                                    backgroundColor: "#fff",
                                                    borderBottom:
                                                        index !== message.buttons.length - 1
                                                            ? "1px solid #d0dff0"
                                                            : "none",
                                                    fontSize: "0.875rem",
                                                    fontWeight: 400,
                                                    transition: "background-color 0.15s ease",
                                                    "&:hover": {
                                                        backgroundColor:
                                                            loading || (i !== messages.length - 1 && disabledFields.intentButton)
                                                                ? "#fff"
                                                                : "#f0f6ff",
                                                    },
                                                }}
                                            >
                                                {button.text}
                                            </Box>
                                        ))}
                                    </Box>
                                ) : (
                                    

                                          <Box sx={{ display: "flex", gap: 1.5, marginTop: ".4rem" }}>
                                                {message.buttons.map((button) => (
                                                    <Button
                                                        disabled={
                                                            loading ||
                                                            (i !== messages.length - 1 && disabledFields.intentButton)
                                                        }
                                                        key={button.value}
                                                        variant="outlined"
                                                        sx={{
                                                            width:'fit-content',
                                                            border: "1px solid #005cb9",
                                                            color: "#005cb9",
                                                        }}
                                                        onClick={() => handleModuleSubmit({ textInput: button.value })}
                                                    >
                                                        {button.text}
                                                    </Button>
                                                ))}
                                            </Box>

                                )}
                            </>
                        )}
                    </div>

                    {message.time && (
                        <Typography
                            sx={{
                                fontSize: "11px",
                                color: "#6b6b6b",
                                paddingX: "4px",
                                marginTop: "3px",
                                textAlign:
                                    message.from === "user" ? "right" : "left",
                            }}
                        >
                            {message.time}
                        </Typography>
                    )}
                </Box>
            ))}

            {loading ? (
                <Box
                    paddingX={1.5}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        marginTop: "1rem",
                    }}
                >
                    <CircularProgress size={18} />
                </Box>
            ) : null}
        </Box>
    );
};

export default Messages;